export function buildMailtoLink(
  email: string | undefined,
  subject?: string,
): string | undefined {
  const trimmed = email?.trim();
  if (!trimmed) return undefined;

  if (!subject) return `mailto:${trimmed}`;
  return `mailto:${trimmed}?subject=${encodeURIComponent(subject)}`;
}
